interface Props {
  category: string;
  type?: 'default' | 'blur' | 'tag' | 'neutral';
  styles?: string;
}

export default function CategoryLabel({ category, type = 'default', styles = '' }: Props) {
  switch (type) {
    case 'blur':
      return (
        <div className={`flex max-w-max rounded bg-white/30 backdrop-blur-sm ${styles}`}>
          <span className="truncate text-nowrap px-2 py-1 text-xs font-medium uppercase leading-[10px] text-white">
            {category}
          </span>
        </div>
      );
    case 'tag':
      return (
        <div
          className={`inline-flex items-end justify-start gap-1.5 rounded border border-zinc-200 bg-white p-3 text-xs font-bold backdrop-blur-[6px] ${styles}`}
        >
          <span className="gradient-category-text">#</span>
          <span className="truncate text-nowrap uppercase">{category}</span>
        </div>
      );
    case 'neutral':
      return (
        <div className={`flex max-w-max rounded bg-gray-200 ${styles}`}>
          <span className="truncate text-nowrap px-2 py-1 text-2xs font-bold uppercase leading-[10px] text-gray-700">
            {category}
          </span>
        </div>
      );
    default:
      return (
        <div className={`flex max-w-max rounded gradient-bg ${styles}`}>
          <span className="truncate text-nowrap px-2 py-1 text-xs font-bold uppercase leading-[10px] gradient-category-text">
            {category}
          </span>
        </div>
      );
  }
}
